import { HttpContextToken } from '@angular/common/http';

/** Set on Insights FastAPI requests so the global interceptor skips withCredentials (CORS-safe). */
export const INSIGHTS_API_REQUEST = new HttpContextToken<boolean>(() => false);
